class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// new code for watching the empty cart

/* ===== Cart drawer auto-sync (bottom of assets/cart-drawer.js) ===== */
(function () {
  if (window.__cartDrawerSync) return;
  window.__cartDrawerSync = true;

  var OPEN_AFTER_ADD = true; // set to false if you don't want the drawer to auto-open
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?([?#]|$)/;
  var _fetch = window.fetch;
  var timer = null;
  var openWanted = false;

  function base() {
    return ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
  }

  function parse(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  // Dawn's own handlers already send "sections" in the request, so skip those
  function hasSections(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') return body.indexOf('sections') !== -1;
      if (body instanceof FormData || body instanceof URLSearchParams) return body.has('sections');
    } catch (e) {}
    return false;
  }

  async function refreshDrawer(open) {
    var drawer = document.querySelector('cart-drawer');
    var target = drawer && drawer.querySelector('#CartDrawer');
    if (!target) return;
    try {
      var res = await _fetch(base() + '/?sections=cart-drawer', { credentials: 'same-origin' });
      if (!res.ok) return;
      var data = await res.json();
      var fresh = data['cart-drawer'] && parse(data['cart-drawer'], '#CartDrawer');
      if (!fresh) return;

      target.innerHTML = fresh.innerHTML;

      var hasItems = !!target.querySelector('.cart-item');
      drawer.classList.toggle('is-empty', !hasItems);
      var items = target.querySelector('cart-drawer-items');
      if (items) items.classList.toggle('is-empty', !hasItems);
      var inner = target.querySelector('.drawer__inner');
      if (inner && hasItems) inner.classList.remove('is-empty');

      // the overlay element was replaced, so re-bind its click
      var overlay = target.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', function () { drawer.close(); });

      if (open && typeof drawer.open === 'function') drawer.open();
    } catch (e) {
      console.error('[cart-drawer sync] failed', e);
    }
  }

  function schedule(open) {
    openWanted = openWanted || !!open;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var o = openWanted;
      openWanted = false;
      refreshDrawer(o);
    }, 150);
  }

  // Manual hook: window.refreshCartDrawer(true) from any custom script
  window.refreshCartDrawer = function (open) { schedule(open); };

  // fetch() calls
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (CART_MUTATION.test(url) && !hasSections(init && init.body)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (r) { if (r && r.ok) schedule(isAdd && OPEN_AFTER_ADD); }).catch(function () {});
    }
    return p;
  };

  // XMLHttpRequest / jQuery.ajax calls
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cdUrl = String(url || '');
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (CART_MUTATION.test(xhr.__cdUrl) && !hasSections(body)) {
      var isAdd = /\/cart\/add/.test(xhr.__cdUrl);
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) schedule(isAdd && OPEN_AFTER_ADD);
      });
    }
    return _send.apply(this, arguments);
  };

  // always show fresh contents when the header cart icon is clicked
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) refreshDrawer(false);
  }, true);
})();